import { takeEvery } from 'redux-saga/effects';

import * as actions from 'store/modules/additionalDrivers';

import { removeDriver } from './utils';

export default function* listenRemoveDriver() {
  yield takeEvery(actions.removeDriver.toString(), removeDriver);
}
